import React from 'react';
import BottomPopup from './index';
import { render } from '../../ApiContainer';

export default class BottomPopupContainer extends React.Component {
  static getInstance() {
    return render(BottomPopupContainer);
  }

  static getResetState(state) {
    const result = {};
    Object.keys(state).forEach((key) => {
      result[key] = undefined;
    });

    return result;
  }

  state = {
    data: {}
  };

  show = (props) => {
    this.setState({
      data: {
        ...props,
        visible: true
      }
    });
  }

  hide = (props) => {
    const { data } = this.state;
    this.setState({
      data: {
        ...data,
        ...props,
        visible: false
      }
    });
  }


  render() {
    const { data } = this.state;
    return (<BottomPopup {...data} onClose={this.hide} />);
  }
}

export function popup(props) {
  return BottomPopupContainer.getInstance().then((instance) => {
    instance.show(props);
  });
}

export function hide(props) {
  return BottomPopupContainer.getInstance().then((instance) => {
    instance.hide(props);
  });
}
